import React from 'react'

const BrandPageGallery = ({ image }) => {

    return (
        <div className="brand-gallery">
            <div className="brand-gallery-image-container">
                <img src={image} className="hero img-fluid brand-gallery-image" role="presentation" alt="Hero" />
                <div className="mobile-image-container">
                    <img src={image} className="hero img-fluid brand-gallery-image mobile-image" role="presentation" alt="Hero" />
                </div>
            </div>

            <div className="controls">
                <button className="prev"></button>
                <button className="next"></button>
            </div>

            <div className="indicators">
                <div className="indicator active"></div>
                <div className="indicator"></div>
                <div className="indicator"></div>
                <div className="indicator"></div>
                <div className="indicator"></div>
            </div>
        </div>
    )
}

export default BrandPageGallery



// WEBPACK FOOTER //
// ./src/components/ads/brandPage/BrandPageGallery.js